type Document = {
  id?: number | null
  contentType?: string | null
  filename?: string | null
  url?: string | null
}

type CleanedDocument = {
  name: string
  type: string
  url: string
}

export const cleanDocuments = (
  documents: (Document | undefined)[],
  signed?: boolean
): CleanedDocument[] => {
  const cleanedDocuments: CleanedDocument[] = documents
    .map((document) => {
      if (!document?.id || !document?.filename || !document?.url || !document?.contentType) {
        return undefined
      }

      return {
        name: document.filename,
        type: document.contentType,
        url: document.url,
        signed,
      }
    })
    .filter(Boolean)

  return cleanedDocuments
}
